import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import { Button, Heading } from '@chakra-ui/react';
import { Loading } from '../../Common/Loading';
import obtenerTitular from '../../../services/obtenerTitular';
import { useTranslation } from 'react-i18next';

//usada por admnistradores y postventas
export default function RutaReporteVentas() {

  const { t } = useTranslation();

  const { titularId } = useParams();
  const [titular, setTitular] = useState({});
  const [error, setError] = useState({ error: false, msg: '' });
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    obtenerTitular(titularId)
      .then((res) => {
        if (res.status === 200) {
          setTitular(res.data.titular);
        } else {
          setError({ error: true, msg: t('ERROR_FETCHING_HOLDER') });
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setError({ error: true, msg: err });
        setIsLoading(false);
      });
  }, [titularId]);

  if (isLoading) return <Loading />;

  return (
    <div className="px-4 py-3">
      {error.error && <h1 className="text-danger">{error.msg}</h1>}
      <div className="d-flex justify-content-between w-25 align-items-center">
        <Heading
          as="h2"
          size="md"
        >
          <Heading as="h2" size="md">{t('HOLDER_NAME')}</Heading>
        </Heading>
        {titular?.nombre} {titular?.apellidos}
      </div>
      <hr className="my-3" />
      <div className="my-4">
        <Heading size="md">{t('HISTORY')}</Heading>
        <div className="mt-4">
          <div>
            <Heading
              as="h5"
              size="md"
              my="2"
            >
              <Heading as="h5" size="md" my="2">{t('LAST_RESERVATION')}</Heading>
            </Heading>
            {titular?.reservacion?.[0] ? (
              <div className="d-flex flex-column w-25">
                <DataRow
                  name={'Nombre'}
                  value={titular?.reservacion?.[0].nombreQuienReserva}
                />
                <DataRow
                  name="Token"
                  value={titular?.reservacion?.[0].token}
                />
                <DataRow
                  name="Fecha de llegada"
                  value={titular?.reservacion?.[0].fechaLlegada.split('T')[0]}
                />
                <DataRow
                  name="Fecha de salida"
                  value={titular?.reservacion?.[0].fechaSalida.split('T')[0]}
                />
                <DataRow
                  name="Tipo de cabaña"
                  value={titular?.reservacion?.[0].tipoCabana}
                />

                <DataRow
                  name="Tipo de reservación"
                  value={titular?.reservacion?.[0].tipoReservacion}
                />
              </div>
            ) : (
              <div>{t('NO_RECENT_RESERVATIONS')}</div>
            )}
          </div>
        </div>
      </div>
      <hr className="my-3" />
      <div className="my-4">
        <Heading size="md">{t('SALES_REPORT')}</Heading>
        <div className="mt-4">
          <div className="w-25">
            <DataRow
              name={t('RELEASED_NIGHTS')}
              value={
                titular?.nochesVenta?.numeroNoches ? titular?.nochesVenta?.numeroNoches : t('NO_RELEASED_NIGHTS')
              }
            />
            <DataRow
              name={t('EARNINGS')}
              value={
                titular?.nochesVenta?.ganancia
                  ? titular?.nochesVenta?.ganancia
                  : 0
              }
            />
          </div>
        </div>
      </div>
      <hr className="my-3" />

      <Button
        onClick={() => navigate('/socios')}
        colorScheme={'yellow'}
        mt={5}
      >
          {t('GO_BACK')}
      </Button>
    </div>
  );
}

export const DataRow = ({ name, value }) => {
  return (
    <div className="d-flex justify-content-between align-items-center">
      <Heading
        as="h3"
        size="sm"
      >
        {name}:
      </Heading>
      <span className="my-1">{value}</span>
    </div>
  );
};
